import { GuidesPage } from "../../GuidesPage";
import { seoContent } from "../../../../constants/SEOConstant";
import { PairSyncGuideContent } from "../../PairSyncGuideContent";

export default function SyncTidalToYoutubeMusic() {
    return (
        <GuidesPage
            seoData={seoContent.syncTidalToYoutubeMusic}
            sections={<PairSyncGuideContent sourceKey="tidal" destKey="youtubeMusic" />}
        />
    );
}
